<template>
  <section class="relative bg-[#F7F7F7] text-gray-900 py-20 px-6 md:px-20">
    <!-- Dekoracyjne narożniki -->
    <div class="absolute top-4 right-4">
      <CornerDecoration />
    </div>
    <div class="absolute bottom-4 left-4">
      <CornerDecoration />
    </div>

    <!-- Nagłówek sekcji -->
    <div class="relative max-w-4xl mx-auto text-center">
      <div class="absolute top-[-7px] left-[-14px] flex flex-col">
        <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
        <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
      </div>
      <div class="absolute bottom-[0px] right-[-14px] flex flex-col items-end">
        <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
        <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
      </div>

      <h2 class="text-5xl font-bold text-[#2E2E2E]">
        W czym się <span class="text-[#E9A53D]">specjalizujemy</span>? Remonty i wykończenia wnętrz
      </h2>
      <p class="mt-4 text-lg text-[#555]">
        Profesjonalne biuro projektowe i wykonawcze z Poznania, oferujące kompleksowe usługi budowlane, aranżacje i remonty.
      </p>
      <div class="w-48 h-[2px] bg-[#E9A53D] mx-auto mt-4"></div>
    </div>

    <!-- Opis firmy -->
    <div class="max-w-screen-lg mx-auto text-center mt-16 px-4">
      <p class="text-xl text-[#444] leading-relaxed">
        Od lat dostarczamy innowacyjne rozwiązania architektoniczne. Nasza pasja do projektowania łączy się z funkcjonalnością, nowoczesnym stylem i najwyższą jakością wykonania. Z nami stworzysz przestrzeń, o której zawsze marzyłeś.
      </p>
    </div>

    <!-- Lista usług -->
    <section class="mt-12 grid grid-cols-1 md:grid-cols-2 gap-12">
      <article
          v-for="(service, index) in services"
          :key="index"
          ref="serviceElements"
          class="flex flex-col items-center text-center opacity-0 transform translate-y-8 transition-all duration-700"
          :class="{ 'opacity-100 translate-y-0': service.visible }"
      >
        <div class="relative w-full h-72">
          <img
              :src="service.image"
              :alt="`Usługa: ${service.title} – ProjectSpot, Poznań`"
              class="w-full h-full object-cover rounded-sm shadow-md"
          />
        </div>
        <h3 class="text-2xl font-semibold text-[#2E2E2E] mt-6">
          {{ service.title }}
        </h3>
        <p class="text-[#555] mt-3">{{ service.description }}</p>
      </article>
    </section>
  </section>
</template>

<script>
import { onMounted, ref, reactive } from 'vue'

export default {
  name: 'ServicesSection',
  components: {
    CornerDecoration: {
      template: `
        <div class="relative w-10 h-10 border-2 border-[#E9A53D]">
          <div class="absolute top-[-7px] left-[-7px] flex flex-col">
            <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
            <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
          </div>
          <div class="absolute bottom-[-7px] right-[-7px] flex flex-col items-end">
            <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
            <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
          </div>
        </div>
      `
    }
  },
  setup() {
    const serviceElements = ref([])
    const services = reactive([
      {
        title: 'Prace wykończeniowe i remontowe – Poznań',
        description: 'Kompleksowe wykończenia wnętrz, remonty mieszkań i domów w Poznaniu – wysoka jakość, terminowość i doświadczenie.',
        image: '/images/components/image1.jpg',
        visible: true
      },
      {
        title: 'Lokale usługowe i biura – aranżacja i realizacja',
        description: 'Projektujemy i urządzamy przestrzenie biurowe oraz usługowe – funkcjonalność i estetyka dla biznesu.',
        image: '/images/components/image2.jpeg',
        visible: true
      },
      {
        title: 'Koordynacja projektów budowlanych – Poznań',
        description: 'Zapewniamy profesjonalny nadzór i koordynację inwestycji, minimalizując ryzyko i opóźnienia.',
        image: '/images/components/image3.jpg',
        visible: true
      },
      {
        title: 'Projekty wnętrz i architektura – Poznań',
        description: 'Tworzymy unikalne projekty domów i wnętrz – od koncepcji po realizację z zachowaniem najwyższych standardów.',
        image: '/images/components/image4.jpg',
        visible: true
      }
    ])

    const revealOnScroll = () => {
      const observer = new IntersectionObserver(
          entries => {
            entries.forEach((entry, index) => {
              if (entry.isIntersecting) {
                services[index].visible = true
                observer.unobserve(entry.target)
              }
            })
          },
          { threshold: 0.1 }
      )

      serviceElements.value.forEach(el => {
        if (el) observer.observe(el)
      })
    }

    onMounted(() => {
      revealOnScroll()
    })

    return {
      services,
      serviceElements
    }
  }
}
</script>

<style scoped>
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.translate-y-8 {
  transform: translateY(32px);
}
.translate-y-0 {
  transform: translateY(0);
}
</style>
